import { cn } from "@pcln/horizon";
const cruiseFormVariants = {
    default: {
        gridContainer: 'grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-[minmax(0,1fr)_minmax(0,1fr)_minmax(0,1fr)_minmax(0,1fr)_max-content]'
    },
    compact: {
        gridContainer: [
            'grid grid-cols-1 gap-3',
            'sm:grid-cols-6',
            "sm:[grid-template-areas:'destination_destination_destination_departure_departure_departure'_'length_length_line_line_search_search']"
        ]
    }
};
const getGridContainerClass = (variant = 'full')=>{
    const v = 'compact' === variant ? 'compact' : 'default';
    return cn(cruiseFormVariants[v].gridContainer, 'mx-auto');
};
const getSubmitButtonClass = (isMobile, variant = 'full')=>{
    if (isMobile) return 'fixed bottom-4 right-4 left-4 sm:[grid-area:search]';
    if ('compact' === variant) return 'w-full sm:[grid-area:search]';
    return 'w-full sm:col-span-2 lg:col-span-1';
};
const inputClassMap = {
    destination: 'sm:[grid-area:destination]',
    departure: 'sm:[grid-area:departure]',
    length: 'sm:[grid-area:length]',
    line: 'sm:[grid-area:line]'
};
const getInputClass = (type, variant = 'full')=>{
    if ('compact' !== variant) return '';
    return inputClassMap[type];
};
export { getGridContainerClass, getInputClass, getSubmitButtonClass };
